import { IconProps } from "@/types/types";

export default function Bell({ width = "24", height = "24", color = "#014042" }: IconProps) {
    return (
        <svg width={width} height={height} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_6753_3)">
                <path fillRule="evenodd" clipRule="evenodd" d="M11 1.83333C7.45618 1.83333 4.58333 4.70618 4.58333 8.25V10.9642C4.58333 12.161 4.1079 13.3088 3.26163 14.1551C2.93404 14.4826 2.75 14.9269 2.75 15.3902V16.1904C2.75 16.8677 3.299 17.4167 3.97623 17.4167H6.93274C6.93274 17.7584 6.93585 18.5888 7.38577 19.4057C8.08443 20.674 9.43928 21.5417 11 21.5417C12.5607 21.5417 13.9155 20.674 14.6142 19.4057C15.0641 18.5888 15.0673 17.7584 15.0673 17.4167H18.0238C18.701 17.4167 19.25 16.8677 19.25 16.1904V15.3902C19.25 14.9269 19.0659 14.4826 18.7384 14.1551C17.8921 13.3088 17.4167 12.161 17.4167 10.9642V8.25C17.4167 4.70618 14.5438 1.83333 11 1.83333ZM12.7756 17.4167C12.7756 17.721 12.7538 18.0334 12.6069 18.3C12.295 18.8663 11.6923 19.25 11 19.25C10.3077 19.25 9.70502 18.8663 9.39308 18.3C9.24623 18.0334 9.22442 17.721 9.22442 17.4167H12.7756Z" fill="currentColor" />
            </g>
            <defs>
                <clipPath id="clip0_6753_3">
                    <rect width={width} height={height} fill="currentColor" />
                </clipPath>
            </defs>
        </svg>
    )
}

